export enum BlockedOperativeEnum {
  all = 'all',
  iban = 'iban',
}

export interface BlockedOperative {
  value: BlockedOperativeEnum;
}

export const blockedOperativeIsAll = (blockedOperative: BlockedOperative): boolean =>
  blockedOperative.value === BlockedOperativeEnum.all;
